var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-navigation-drawer',{staticStyle:{"margin":"1px"},attrs:{"app":"","value":_vm.visible,"width":"330","mini-variant":true,"expand-on-hover":""},on:{"input":function($event){return _vm.$emit('update:visible', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }